import React from 'react'
import './index.scss'

interface LabelPriceProps {
    price: number
    color: string
}

export const LabelPrice: React.FC<LabelPriceProps> = ({ price, color }) => {
    const isDefault = color.toUpperCase() === 'DEFAULT'
    const backgroundColor = isDefault ? 'transparent' : `${color}20` // branco ou cor com 20% opacidade
    const textColor = isDefault ? '#000000' : color

    return (
        <div
            className="countPrice"
            style={{
                backgroundColor,
                color: textColor,
            }}
        >
            {price != 0
                ? price.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                  })
                : '-'}
        </div>
    )
}
